export const settings = {
    "title": "Gate 51",
    "description": "Gate 51",
    "apiUrl": "https://localhost/api",
    "ckdPath": "https://localhost/"
}